<template>
  <div :data-test-id="dataTestId">
    <p v-if="!!(fields?.title?.value ?? title?.value)" class="font-sans font-medium text-racq-dark-grey">
      {{ fields?.title?.value ?? title?.value }}
    </p>
    <div :class="fields?.outerClass?.value ?? outerClass?.value">
      <div class="w-full overflow-x-scroll no-scrollbar py-3 last:pb-0">
        <ul
          class="py-2 flex flex-nowrap md:flex-wrap gap-x-3 gap-y-4 pl-4 md:pl-0"
          :class="fields?.innerClass?.value ?? innerClass?.value"
        >
          <li v-for="(item, index) in fields.childItems ?? fields" :key="index" class="p-0 m-0">
            <Link
              :href="handleLinkClickEvent ? 'javascript:void(0)' : (item?.link?.value?.href ?? item?.value?.link?.href)"
              :data-test-id="(item.fields?.dataTestId ?? item?.dataTestId)?.value"
              :field="item.fields?.link ?? item?.link"
              :class="{
                'flex flex-nowrap items-center gap-[6px] px-6 py-[7px] no-underline active:no-underline whitespace-nowrap !rounded-3xl bg-true-white hover:bg-racq-pale-blue active:bg-racq-white !border-[1.5px] border-racq-light-blue-grey hover:border-racq-blue-border active:border-racq-blue-active text-racq-med-grey text-base-bold active:text-racq-navy': true,
                'pl-4': getIconPosition(item) === 'left',
                'pr-4': getIconPosition(item) === 'right',
                disabled: (item.fields?.disabled?.value ?? item.disabled?.value) === '1',
              }"
              @click="onClick(item)"
            >
              <div v-if="getIconPosition(item) === 'left'" class="w-[16px]">
                <Image
                  :media="((item.fields?.icon ?? item?.icon) as Field<ImageFieldValue>)?.value"
                  class="w-[16px]"
                  width="16"
                  height="16"
                />
              </div>
              <div>{{ item.fields?.link?.value?.text ?? item.link?.value?.text }}</div>
              <div v-if="getIconPosition(item) === 'right'" class="w-[16px]">
                <Image
                  :media="((item.fields?.icon ?? item.icon) as LinkField)?.value"
                  class="w-[16px]"
                  width="16"
                  height="16"
                />
              </div>
            </Link>
          </li>
          <div class="w-4 md:hidden flex-shrink-0">
            <!-- Needed to add space at the end of the list on mobile -->
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Item, Field, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import { Image, Link } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';
import { usePageStore } from '@/store';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

const props = withDefaults(
  defineProps<{
    // PageBuilder
    title?: Field<string>;
    innerClass?: Field<string>;
    outerClass?: Field<string>;
    fields: {
      // PageBuilder
      link?: LinkField;
      icon?: ImageField;
      iconPosition?: Field<string>;

      // Experience editor
      childItems?: Item[];
      title?: Field<string>;
      outerClass?: Field<string>;
      innerClass?: Field<string>;
      dataTestId?: Field<string>;
    };
    rendering?: ComponentRendering;
    handleLinkClickEvent?: boolean;
  }>(),
  {
    title: undefined,
    innerClass: undefined,
    outerClass: undefined,
    rendering: undefined,
    handleLinkClickEvent: false,
  }
);

const dataTestId = usePageStore().dataTestId(props.rendering);

const getIconPosition = (item: Item) => ((item.fields?.iconPosition ?? item.iconPosition) as Field<string>)?.value;

const emit = defineEmits(['btnClick']);

const onClick = (linkItem: any) => {
  if (!props.handleLinkClickEvent) return;
  emit('btnClick', linkItem);
};
</script>
